import { Outlet } from 'react-router-dom'
import NavBar from './NavBar'
import Sidebar from './Sidebar'

export const MainLayout = () => {
  return (
    <div className="flex">
      <Sidebar />
      <div className="w-full">
        <NavBar />
        <Outlet />
      </div>
    </div>
  )
}
